export default "__VITE_PUBLIC_ASSET__868b1bd4__"